<template>
  <div class="row">
    <div class="col-12 col-md-9">
      <div class="card">
        <div class="card-body">
          <div class="card-title">Working Days / Hours</div>
          <table class="table">
            <tbody>
              <tr>
                <td style="line-height: 33px">Monday</td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="start time"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="end time"
                  />
                </td>
              </tr>
              <tr>
                <td style="line-height: 33px">Tuesday</td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="start time"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="end time"
                  />
                </td>
              </tr>
              <tr>
                <td style="line-height: 33px">Wednesday</td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="start time"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="end time"
                  />
                </td>
              </tr>
              <tr>
                <td style="line-height: 33px">Thursday</td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="start time"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="end time"
                  />
                </td>
              </tr>
              <tr>
                <td style="line-height: 33px">Friday</td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="start time"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="end time"
                  />
                </td>
              </tr>
              <tr>
                <td style="line-height: 33px">Saturday</td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="start time"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="end time"
                  />
                </td>
              </tr>
              <tr>
                <td style="line-height: 33px">Sunday</td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="start time"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="end time"
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="col-sm-12 col-md-2" style="margin-left: auto">
              <button
                type="button"
                class="btn btn-success waves-effect waves-light w-100"
              >
                Save
              </button>
            </div>
            <div class="col-sm-12 col-md-2">
              <button
                type="button"
                class="btn btn-primary waves-effect waves-light w-100"
              >
                Reset
              </button>
            </div>
          </div>
          <!-- <vue-cal
            class="vuecal--blue-theme"
            :events="events"
            selected-date="2018-11-19"
            :time-from="9 * 60"
            :time-to="23 * 60"
            :disable-views="['years', 'year', 'month', 'day']"
            hide-view-selector
            hide-weekends
            hide-title-bar
            @cell-click="onEventClick"
            :cell-click-hold="false"
          >
            <template #no-event=""></template>
          </vue-cal> -->
        </div>
      </div>
    </div>
    <div class="col-12 col-md-3">
      <div class="card">
        <div class="card-body">
          <div class="card-title">Schedule Setting</div>

          <div v-if="loadingCalendar" class="wrap-loading-calendar">
            <b-spinner class="align-middle mr-2"></b-spinner>
          </div>

          <FullCalendar ref="fullCalendar" :options="calendarOptions" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCal from 'vue-cal'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list'
import { activitiyService } from '../services/activities.service'

import 'vue-cal/dist/vuecal.css'
export default {
  name: 'UserScheduleWorking',
  components: {
    VueCal,
    FullCalendar
  },
  data () {
    return {
      loadingCalendar: false,
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin, listPlugin],
        initialView: 'listWeek',
        events: [],
        height: 452,
        eventClick: this.showEvent
      },
      events: []
    }
  },
  computed: {},
  mounted: function () {
    activitiyService.getData().then((rs) => {
      rs.forEach((event) => {
        const evt = {
          title: event.title,
          data: event,
          date: event.start,
          id: event.id
        }
        this.events.push(evt)
      })
      this.$nextTick(() => {
        this.loadingCalendar = false
        if (this.$refs.fullCalendar) {
          this.$refs.fullCalendar.getApi().addEventSource(this.events)
        }
      })
    })
  },
  methods: {
    onEventClick (event, e) {
      console.log(event)

      // Prevent navigating to narrower view (default vue-cal behavior).
      e.stopPropagation()
    }
  }
}
</script>

<style lang="css">
/* You can easily set a different style for each split of your days. */
.vuecal__cell-split.dad {
  background-color: rgba(221, 238, 255, 0.5);
}
.vuecal__cell-split.mom {
  background-color: rgba(255, 232, 251, 0.5);
}
.vuecal__cell-split.kid1 {
  background-color: rgba(221, 255, 239, 0.5);
}
.vuecal__cell-split.kid2 {
  background-color: rgba(255, 250, 196, 0.5);
}
.vuecal__cell-split.kid3 {
  background-color: rgba(255, 206, 178, 0.5);
}
.vuecal__cell-split .split-label {
  color: rgba(0, 0, 0, 0.1);
  font-size: 26px;
}

/* Different color for different event types. */
.vuecal__event.leisure {
  background-color: rgba(253, 156, 66, 0.9);
  border: 1px solid rgb(233, 136, 46);
  color: #fff;
}
.vuecal__event.health {
  background-color: rgba(164, 230, 210, 0.9);
  border: 1px solid rgb(144, 210, 190);
}
.vuecal__event.sport {
  background-color: rgba(255, 102, 102, 0.9);
  border: 1px solid rgb(235, 82, 82);
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/UserScheduleWorking.vue